import { DOCUMENT } from "@angular/common";
import {
  Directive,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import {
  Observable,
  Subscription,
  fromEvent as observableFromEvent,
  merge as observableMerge
} from "rxjs";

const SCROLL_OBSERVABLE_CACHE: WeakMap<
  HTMLElement | Document,
  Observable<Event>
> = new WeakMap<HTMLElement | Document, Observable<Event>>();
function getScrollObservable(el: HTMLElement | Document): Observable<Event> {
  if (SCROLL_OBSERVABLE_CACHE.has(el)) {
    return SCROLL_OBSERVABLE_CACHE.get(el)!;
  }
  let observable: Observable<Event> = observableFromEvent(el, "scroll");
  SCROLL_OBSERVABLE_CACHE.set(el, observable);
  return observable;
}

@Directive({
  selector: "[taAncestorScroll]"
})
export class AncestorScrollDirective implements OnInit, OnDestroy {
  @Output()
  taAncestorScroll: EventEmitter<Event> = new EventEmitter<Event>();

  @Input()
  get taAncestorScrollDisabled(): boolean {
    return this._taAncestorScrollDisabled;
  }
  set taAncestorScrollDisabled(value: boolean) {
    value = value != null && value !== false;

    if (this._taAncestorScrollDisabled === value) {
      return;
    }

    this._taAncestorScrollDisabled = value;

    if (this.initted) {
      if (value) {
        this.cancelSubscription();
      } else {
        this.initSubscription();
      }
    }
  }
  private _taAncestorScrollDisabled: boolean = false;

  get disabled(): boolean {
    return this._taAncestorScrollDisabled;
  }

  private documentRef: Document;
  constructor(private elemRef: ElementRef, @Inject(DOCUMENT) documentRef: any) {
    this.documentRef = documentRef;
  }

  private initted: boolean = false;
  ngOnInit(): void {
    setTimeout(() => {
      if (!this.disabled) {
        this.initSubscription();
      }
      this.initted = true;
    });
  }

  ngOnDestroy(): void {
    this.cancelSubscription();
  }

  private initSubscription(): void {
    if (this._parentScrollSubscription != null) {
      return;
    }

    this._parentScrollSubscription = observableMerge(
      ...this.getAncestors().map(getScrollObservable)
    ).subscribe(this.taAncestorScroll.emit.bind(this.taAncestorScroll));
  }

  private _parentScrollSubscription?: Subscription;
  private cancelSubscription(): void {
    if (this._parentScrollSubscription == null) {
      return;
    }
    this._parentScrollSubscription.unsubscribe();
    this._parentScrollSubscription = undefined;
  }

  private getAncestors(): Array<HTMLElement | Document> {
    let currentElem: HTMLElement = this.elemRef.nativeElement,
      ancestors: Array<HTMLElement | Document> = [this.documentRef];
    while (currentElem.parentElement) {
      currentElem = currentElem.parentElement;
      ancestors.push(currentElem);
    }

    return ancestors;
  }
}
